module.exports = __webpack_public_path__ + "static/img/default_face.8a9e59c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/default_face.png
// module id = 827
// module chunks = 0